import * as React from 'react';
import styled from 'styled-components';
import { useQuery } from 'data-fetching-client';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { H2 } from 'UIComponents/elements/headings';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIModal from 'UIComponents/dialog/UIModal';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import { getEventTypeIdFromObj } from 'automation-ui-enrollment/utils/eventFilters';
import WebhookModalUsageBody from 'automation-ui-enrollment/components/eventEnrollment/WebhookModalUsageBody';
import { GET_UNIFIED_EVENT_USAGES } from 'automation-ui-enrollment/queries/CrmUsageQueries';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import { useTrackEvent } from 'automation-ui-usage-tracking/usageTrackingHooks';

// Needed to prevent the private modal styles from overriding
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledUIErrorMessage = styled(UIErrorMessage).withConfig({
  displayName: "WebhookDeleteModal__StyledUIErrorMessage",
  componentId: "sc-1cgyi4k-0"
})(["margin-top:0 !important;& > h4{font-size:20px !important;}"]);
const WebhookDeleteModal = ({
  objectTypeId,
  webhookDefinition,
  onClose,
  handleWebhookDelete
}) => {
  const {
    error,
    loading,
    data,
    refetch
  } = useQuery(GET_UNIFIED_EVENT_USAGES, {
    variables: {
      eventType: 'PORTAL_SPECIFIC_EVENT',
      eventTypeId: getEventTypeIdFromObj(webhookDefinition.eventTypeId)
    },
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'network-only'
  });
  const trackEvent = useTrackEvent();
  const hasWebhookUsages = Boolean(data && data.unifiedEventUsages.length > 0);
  const showCheckAgainButton = !!error || hasWebhookUsages;
  return /*#__PURE__*/_jsxs(UIModal, {
    use: "danger",
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "automation-ui-enrollment.webhookWizard.deleteModal.title",
          options: {
            webhookName: webhookDefinition.label
          }
        })
      }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: onClose
      })]
    }), /*#__PURE__*/_jsx(UIDialogBody, {
      children: error ? /*#__PURE__*/_jsx(StyledUIErrorMessage, {
        title: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "automation-ui-enrollment.webhookWizard.deleteModal.error.title"
        }),
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "automation-ui-enrollment.webhookWizard.deleteModal.error.description"
        })
      }) : loading || !data ? /*#__PURE__*/_jsx(UILoadingSpinner, {
        layout: "centered"
      }) : /*#__PURE__*/_jsx(WebhookModalUsageBody, {
        crmUsages: data.unifiedEventUsages
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        ,
        onRefetch: refetch,
        webhookDefinition: webhookDefinition
      })
    }), /*#__PURE__*/_jsxs(UIDialogFooter, {
      children: [/*#__PURE__*/_jsxs(UILoadingButton, {
        use: showCheckAgainButton ? 'tertiary' : 'danger',
        disabled: !error && (loading || !data),
        loading: loading && hasWebhookUsages,
        onClick: () => {
          if (showCheckAgainButton) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            refetch();
          } else {
            trackEvent(Trackables.WEBHOOK_TRIGGER_MODIFIED, {
              editType: 'DELETE_CONFIRM',
              objectTypeId
            });
            handleWebhookDelete(webhookDefinition.definitionId);
            onClose();
          }
        },
        children: [showCheckAgainButton && /*#__PURE__*/_jsx(UIIcon, {
          name: "refresh"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: showCheckAgainButton ? 'automation-ui-enrollment.webhookWizard.deleteModal.footer.checkAgain' : 'automation-ui-enrollment.webhookWizard.deleteModal.footer.deleteEvent',
          options: {
            webhookName: webhookDefinition.label
          }
        })]
      }), /*#__PURE__*/_jsx(UIButton, {
        use: "tertiary-light",
        onClick: onClose,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.webhookWizard.deleteModal.footer.cancel"
        })
      })]
    })]
  });
};
export default WebhookDeleteModal;